<template>
    <div>
        <div class="grid-container">
            <div v-for="(successItem, index) in success" :key="index + 'grid'" class="grid-item">
                <img :src="successItem.src" alt="">
                <h3>{{ successItem.name }}</h3>
            </div>
        </div>
    </div>
</template>

<script>
import { success } from '@/view/success.js'

export default {
    name: 'SuccessText',
    data(){
        return {
            success
        }
    }
}
</script>

<style scoped>
.content {
  width: 80%;
  margin: auto;
}
.grid-container {
    display: grid;
    width: 70%;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px; /* 格子之间的间距 */
    margin: auto;
    margin-top: 50px;
    text-align: left;
}

.grid-item  img{
    width: 100%;
    height: 230px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2em;
    margin: auto;
}
.grid-container a {
    font-size: 14px;
    color: #1e7962;
    padding: 0 20px 20px;
    display: block;
    text-decoration: none;
}
h3 {
    padding: 0 20px;
}
</style>